export class SalesPerson {
    SlpCode: number;
    SlpName: string;
}
